import { API } from "../../allApi";
import { haveToApiService } from "../../plugins/axios";
import {
  TransferWalletResources,
  TransferWallet,
  TransferBalanceRequest,
  TransferBalanceResponse,
} from "./types";

const TRANSFER_ENDPOINTS: TransferWalletResources = {
  TRANSFER_BALANCE: {
    URL: API.TRANSFER_WALLET_BALANCE.URL,
    METHOD: API.TRANSFER_WALLET_BALANCE.METHOD,
  },
  CALCULATE_BLOCK_GAS_FEE: {
    URL: API.CALCULATE_BLOCK_GAS_FEE.URL,
    METHOD: API.CALCULATE_BLOCK_GAS_FEE.METHOD,
  },
};

const haveToAPI: TransferWallet = {
  // Transfer wallet balance
  transferWalletBalance: async (payload: TransferBalanceRequest) => {
    const { response, error } = await haveToApiService({
      resource: TRANSFER_ENDPOINTS.TRANSFER_BALANCE,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("userAuthToken")}`,
      },
      options: {
        data: {
          sender_address: payload.senderAddress,
          receiver_address: payload.receiverAddress,
          amount: payload.Amount,
          max_fee_per_gas: payload.gasFee,
          max_priority_fee_per_gas: payload.priorityFee,
          data: "string",
          transaction_type: "TRANSFER",
        },
      },
    });
    if (response.transaction_status !== "SUCCESS") {
      return { error: `${error} Transaction Failed` };
    } else {
      return { error: null };
    }
  },
  // Calculate block gas fee
  calculateBlockGasFee: async () => {
    const { response, error } = await haveToApiService({
      resource: TRANSFER_ENDPOINTS.CALCULATE_BLOCK_GAS_FEE,
    });
   
    if (response) {
      return { error: null, ...response };
    } else {
      return { error: error?.message || "Failed to fetch gas fees" };
    }
  },
};
export default haveToAPI;
export { TRANSFER_ENDPOINTS };
